import decoder from '../../../lib/decoder';

function ModelProvider() {
	this.id = 0;
	this.name = '';
	this.logo = '';
}

ModelProvider.create = function (json) {
	if (!json) json = {};
	
	let model = new ModelProvider();
	
	model.id = decoder.intValue(json['id'], 0);
	model.name = decoder.stringValue(json['name'], '');
	model.logo = decoder.stringValue(json['logo'], '');
	
	return model;
};

export default ModelProvider;